import { render, staticRenderFns } from "./ActiveProduct.vue?vue&type=template&id=62839071&scoped=true&"
import script from "./ActiveProduct.vue?vue&type=script&lang=js&"
export * from "./ActiveProduct.vue?vue&type=script&lang=js&"
import style0 from "./ActiveProduct.vue?vue&type=style&index=0&id=62839071&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62839071",
  null
  
)

export default component.exports